export enum invalidValueKey {
  TED_VALID_MAX_AMOUNT = 'TED_VALID_MAX_AMOUNT',
  TED_VALID_MIN_AMOUNT = 'TED_VALID_MIN_AMOUNT',
  P2P_VALID_MAX_AMOUNT = 'P2P_VALID_MAX_AMOUNT',
  P2P_VALID_MIN_AMOUNT = 'P2P_VALID_MIN_AMOUNT',
}

export enum invalidValueInterpolation {
  MAX_VALUE = 'maxValue',
  MIN_VALUE = 'minValue',
}
